import {Select} from "@/theme";

export function paginationHelper(pagination, onChange){
    if (pagination.last_page > 1){
        return{
            current: pagination.current_page,
            pageSize: pagination.per_page,
            total: pagination.total,
            count: pagination.to,
            total_pages: pagination.last_page,
            onChange: onChange,
            showSizeChanger: false,
            showQuickJumper: false,
            locale: { page: '' },
            defaultCurrent: 1,
            showTotal: () => (
                <div className={'go_to_page'}>
                    <div>
                        Page
                    </div>

                    <Select
                        options={[...Array(pagination.last_page)].map((_item, key)=>({
                            value: key + 1, label: key + 1
                        }))}
                        value={pagination.current_page}
                        onChange={onChange}
                        style={{
                            width: 64,
                            height: 28,
                            margin: '0 8px'
                        }}
                    />
                    of
                   <div>
                       &nbsp; {pagination.last_page}
                   </div>
                </div>
            )
        };
    }

    return false
}
